// extracted by mini-css-extract-plugin
export default {"loginForm":"style-loginForm-3k-iV","footerWrapper":"style-footerWrapper-2bsOQ","smallWarning":"style-smallWarning-3QH9A","disabled":"style-disabled-BMWs6"};